export default "/img/IL.cf25bc52c9723ef00808c1f6c1934394.png";